export const ATTENDANCE_REPORT_STATE = {
    report_month: ""
}